<template>
  <div class="liff-reservation-form">
    <DynamicForm
      ref="dynamicForm"
      :input-subjects="fields"
      v-model="dynamicFormInput"
      :phone-verification-config="phoneVerificationConfig"
      @file-uploading="updateFileUploading"
    />

    <div class="wizard-mode-layout__footer-navigation">
      <div class="wizard-mode-layout__footer-button-wrapper">
        <button
          class="s-btn s-liff-theme-btn-outline s-btn-sm"
          type="button"
          :disabled="isFileUploading"
          @click="handleNegativeButtonClicked"
          v-if="hasPreviousStep()"
        >
          上一步
        </button>
        <button
          class="s-btn s-liff-theme-btn s-btn-sm"
          type="button"
          :disabled="isFileUploading"
          @click="handlePositiveButtonClicked"
        >
          {{ textForProceedButton() }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import { mapActions, mapGetters, mapState } from 'vuex';
import SharedButton from '@/components/Page/Liff/Shared/Button.vue';
import DynamicForm from "@/components/DynamicForm/DynamicForm.vue";
import BookingPresetDataModel from '@/models/BookingPreset.model';
import DynamicFormField from '@/models/DynamicFormField.model';

export default {
  components: {
    SharedButton,
    DynamicForm,
  },
  inject: ['back', 'proceed', 'hasPreviousStep', 'textForProceedButton'],
  data() {
    return {
      dynamicFormInput: {},
      isFileUploading: false
    };
  },
  computed: {
    ...mapGetters('liffAuth', ['user']),
    ...mapState('liffBookingWizard', ['bookingPreset', 'selectedServiceIds', 'extraFormData']),
    dataModel() {
      return new BookingPresetDataModel(this.bookingPreset);
    },
    fields() {
      return DynamicFormField.fromArray(_.get(this.bookingPreset, 'config.fields', []))
        .filter(fieldModel => this.dataModel.customerVisibleFieldsInWizard(fieldModel))
        .map(fieldModel => fieldModel.flattenedAttributes());
    },
    branchId() {
      return this.$route.query.branch_id;
    },
    staffId() {
      return this.$route.query.staff_id;
    },
    phoneVerificationConfig() {
      return {
        enabled: this.dataModel.phoneVerificationTiming === 'current_page',
        field_id: this.dataModel.phoneVerificationFieldId
      }
    },
    phoneVerificationIsRequired() {
      return this.phoneVerificationConfig.enabled && this.phoneVerificationConfig.field_id
    },
  },
  mounted() {
    this.init();
  },
  methods: {
    ...mapActions('liffBookingWizard', ['fetchBookingPreset', 'setExtraFormData']),
    updateFileUploading(val) {
      this.isFileUploading = val;
    },
    async init() {
      await this.fetchBookingPreset({ bookingPresetId: this.$route.params.bookingPresetId, branchId: this.branchId });

      this.dynamicFormInput = this.extraFormData || {}; // NOTE: required for data to be present when user navigates back

      this.fields.forEach(field => {
        const assignKey = field.assign_to_customer_data || _.get(field, 'config.assign_to_customer_data');
        if (assignKey && [null, undefined].includes(this.dynamicFormInput[field._id])) {
          this.$set(this.dynamicFormInput, field._id, _.get(this.user, assignKey));
        }
      });
    },
    handleNegativeButtonClicked() {
      this.back()
    },
    async handlePositiveButtonClicked() {
      if (this.isFileUploading) {
        return;
      }

      const result = await this.$refs.dynamicForm.validate();
      if (result) {
        this.setExtraFormData(this.dynamicFormInput);
        await this.proceed();
      }
    },
  }
};
</script>

<style lang="scss" scoped>
.liff-reservation-form{
  padding-bottom: 80px;
}
</style>
